define([
    'jquery',
    './helpers/console'
], function($, console) {
    'use strict';

    var init = function() {
        console.log('init');

        $(document).on('mouseover', ".hoverable > li, .hoverable_only > li", function() {
            $(this).addClass('hover');
        });

        $(document).on('mouseout', ".hoverable > li, .hoverable_only > li", function() {
            $(this).removeClass('hover');
        });

        $('.hoverable > li').on('click', function (event) {
            event.preventDefault();

            var href = $(this).find("a[rel*=external]").attr("href");
            if (href) {
                window.open(href);
            } else {
                var img_href = $(this).find("a.gallery").attr("href");
                if (img_href) {
                    $(this).find("a.gallery").trigger('click');
                } else {
                    var link = $(this).find("a").attr("href");
                    if (link) {
                        window.location = link;
                    }
                }
            }
        });

        /**
         * Home spots
         */
        if ($('.grid-list').length === 0) {
            return;
        }

        $('.grid-list li').each(function(index, obj) {
            var $li = $(obj),
                link = $li.data('page_link');

            if (link) {
                $li.css({'cursor': 'pointer'});
            }
        });

        $(document).on('click', '.grid-list li', function(event) {
            event.preventDefault();

            var $li = $(this),
                link = $li.data('page_link');
            if (link) {
                window.location = link;
            }
        });




    };

    return {
        init: init
    };
});